import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Panel, btnSecondary, errMsg } from "./ui";

const STATUS = { connected: ["API Connected", "text-[#35C78A] border-[#35C78A]"], error: ["API Error", "text-[#F06464] border-[#F06464]"], not_configured: ["Belum dikonfigurasi", "text-[#A8A8AD] border-[#35353B]"] };

export default function BinancePaySettings() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/binance-pay").then((r) => setS(r.data)).catch(() => {}); }, []);
  const run = async (fn, ok) => {
    setBusy(true);
    try { const r = await fn(); setS(r.data); toast.success(ok); }
    catch (e) { toast.error(errMsg(e)); api.get("/admin/binance-pay").then((r) => setS(r.data)); } finally { setBusy(false); }
  };
  if (!s) return null;
  const [label, cls] = s.configured ? (STATUS[s.api_status] || STATUS.not_configured) : STATUS.not_configured;

  return (
    <Panel title="Binance Pay Merchant (Otomatis)" testId="binance-pay-settings">
      <div className="flex flex-wrap items-center gap-3 mb-3">
        <label className="flex items-center gap-2 text-sm text-[#F5F3ED] cursor-pointer">
          <input data-testid="bp-enabled-toggle" type="checkbox" checked={s.enabled} disabled={busy || !s.configured} onChange={(e) => run(() => api.put("/admin/binance-pay", { enabled: e.target.checked }), e.target.checked ? "Binance Pay otomatis diaktifkan" : "Binance Pay otomatis dinonaktifkan")} className="accent-[#D4AF37]" />
          Aktif di checkout (Binance Pay manual disembunyikan saat aktif)</label>
        <span data-testid="bp-api-status" className={`text-[10px] font-bold border rounded-sm px-2 py-0.5 ${cls}`}>{label}</span>
        <button data-testid="bp-test-btn" disabled={busy || !s.configured} onClick={() => run(() => api.post("/admin/binance-pay/test"), "Koneksi Binance Pay berhasil")} className={btnSecondary}>Tes Koneksi</button>
      </div>
      {s.api_error && <div data-testid="bp-api-error" className="text-xs text-[#F06464] border border-[#F06464]/40 bg-[#F06464]/10 rounded-sm px-3 py-2 mb-3">{s.api_error}</div>}
      {!s.configured && (
        <div data-testid="bp-config-needed" className="text-xs text-[#F2D98D] mb-3">Kredensial belum diatur. Tambahkan di Secrets server: {s.required_env.map((k) => <code key={k} className="mx-1 text-[#D4AF37]">{k}</code>)}</div>
      )}
      <div className="text-xs text-[#A8A8AD]">Webhook URL (daftarkan di Binance Merchant Portal → Developers): <code data-testid="bp-webhook-url" className="text-[#D4AF37] break-all">{s.webhook_url}</code></div>
    </Panel>
  );
}
